import { render } from "./CustomersFormComponent.vue?vue&type=template&id=10be69af"
import script from "./CustomersFormComponent.vue?vue&type=script&lang=js"
export * from "./CustomersFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__